/**
 * Release Notes Hook (Issue #933)
 *
 * Phase 1: Returns static data from TypeScript file.
 * Phase 2: Will use useQuery to fetch from /api/content/release-notes
 *
 * Interface matches TanStack Query pattern for seamless API transition:
 * - data: The release notes array
 * - isLoading: Always false for static data
 * - error: Always null for static data
 */

import { RELEASE_NOTES } from '../data/releaseNotes';
import type { ReleaseNote } from '../types/cms';

interface UseReleaseNotesResult {
  data: ReleaseNote[];
  isLoading: boolean;
  error: null;
}

/**
 * Hook to fetch release notes.
 *
 * Returns static data with TanStack Query-compatible interface.
 */
export function useReleaseNotes(): UseReleaseNotesResult {
  // Phase 1: Static data, no loading state
  return {
    data: RELEASE_NOTES,
    isLoading: false,
    error: null,
  };
}

// ============================================================================
// Phase 2 (future API-backed implementation):
// ============================================================================
//
// import { useQuery } from '@tanstack/react-query';
// import { apiGet } from '../lib/api';
// import type { ReleaseNote } from '../types/cms';
//
// interface ReleaseNotesResponse {
//   release_notes: ReleaseNote[];
// }
//
// export function useReleaseNotes() {
//   return useQuery({
//     queryKey: ['cms', 'release-notes'],
//     queryFn: () => apiGet<ReleaseNotesResponse>('/api/content/release-notes'),
//     select: (data) => data.release_notes,
//     staleTime: 1000 * 60 * 60, // 1 hour - release notes don't change often
//   });
// }
